<template>
  <AppHeader />
  <div class="min-h-screen bg-blue-50">
    <!-- Header section with UP colors -->
    <div class="bg-gradient-to-r from-blue-900 to-blue-700 py-8 shadow-md">
      <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div class="flex flex-col items-center">
          <div class="text-center">
            <h1 class="text-2xl font-bold text-white mb-1">Reset Password</h1>
            <p class="text-blue-100">Get back into your account</p>
          </div>
        </div>
      </div>
    </div>

    <!-- Main content -->
    <div class="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-6">
      <div class="grid grid-cols-1 max-w-md mx-auto">
        <div class="bg-white rounded-lg shadow transform transition-transform duration-300 hover:-translate-y-1 hover:shadow-md">
          <div class="p-6">
            <div class="text-center mb-6">
              <div class="mx-auto mb-4 flex items-center justify-center w-16 h-16 rounded-full bg-blue-100">
                <span class="material-symbols-outlined text-3xl text-blue-800">lock_reset</span>
              </div>
              <p class="text-gray-600 mb-6">Enter your email to receive a password reset link</p>
            </div>

            <form class="space-y-5" @submit.prevent="resetPassword">
              <!-- Email Input -->
              <div>
                <label for="email" class="block text-sm font-medium text-gray-700 mb-1">Email</label>
                <div class="relative">
                  <div class="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                    <span class="material-symbols-outlined text-gray-400">mail</span>
                  </div>
                  <input
                    id="email"
                    v-model="email"
                    type="email"
                    required
                    class="block w-full pl-10 pr-3 py-3 border border-gray-300 rounded-lg shadow-sm focus:ring-2 focus:ring-blue-900 focus:border-blue-900 placeholder-gray-400 transition duration-200"
                    placeholder="your@email.com"
                  />
                </div>
              </div>

              <!-- Success Message -->
              <div v-if="message" class="flex items-center p-3 rounded-lg bg-green-50 border border-green-200 text-green-700 text-sm">
                <span class="material-symbols-outlined text-green-600 mr-2">check_circle</span>
                <p>{{ message }}</p>
              </div>

              <!-- Submit Button -->
              <button
                type="submit"
                class="w-full flex items-center justify-center py-3 px-4 rounded-lg font-semibold text-white bg-gradient-to-r from-blue-900 to-blue-700 hover:from-blue-800 hover:to-blue-600 transition"
              >
                Send Reset Link
                <span class="material-symbols-outlined ml-2">send</span>
              </button>

              <div class="relative h-px bg-gray-100 my-6">
                <span class="absolute left-1/2 -translate-x-1/2 -top-3 bg-white px-3 text-xs text-gray-400">OR</span>
              </div>

              <router-link to="/login" class="w-full flex items-center justify-center py-3 px-4 rounded-lg font-semibold text-blue-900 border border-blue-900 bg-white hover:bg-blue-50 transition">
                Back to Login
                <span class="material-symbols-outlined ml-2">arrow_back</span>
              </router-link>
            </form>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { sendPasswordReset } from '@/composables/useAuth';
import AppHeader from '@/components/common/AppHeader.vue';

export default {
  components: {
    AppHeader
  },
  data() {
    return {
      email: '',
      message: ''
    };
  },
  methods: {
    async resetPassword() {
      if (!this.email) {
        this.$store.dispatch('showAlert', { message: "Please enter your email.", type: "error" });
        return;
      }

      try {
        await sendPasswordReset(this.email);
        this.message = "Password reset email sent! Check your inbox.";
        this.$store.dispatch('showAlert', { message: "Password reset email sent!", type: "success" });
      } catch (error) {
        this.$store.dispatch('showAlert', { message: error.message, type: "error" });
      }
    }
  }
};
</script>

<!-- No custom CSS needed, all styling is handled by Tailwind classes -->